import { useTranslation } from 'libs/i18n'
import type { Option } from 'shared/components/ContextMenu/types'
import type { GenderItem } from 'features/genders/types/genders.types'

type UseContextMenuOptionsProps = {
	onEdit: (gender: GenderItem) => void
	onDelete: (id: number) => void
}

export const useContextMenuOptions = ({
	onEdit,
	onDelete
}: UseContextMenuOptionsProps): Option[] => {
	const { t } = useTranslation()

	return [
		{
			label: t('Edit'),
			action: (_id: number, gender: GenderItem) => onEdit(gender)
		},
		{
			label: t('Delete'),
			action: onDelete
		}
	]
}
